import React, { FC } from 'react';
import '../../App.scss';
import styles from './styles.module.scss';
import pink from '../../assets/diamonds/pink.svg';
import blue from '../../assets/diamonds/blue.svg';
import green from '../../assets/diamonds/green.svg';
import { Colors } from '../../constants/colorMap';

interface IDiamondButtonProps {
  text: string;
  onClick: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void | Promise<void> | object;
  color?: Colors;
}

const DiamondButton: FC<IDiamondButtonProps> = ({
  text,
  onClick,
  color = 'pink',
}) => {
  const handleClick = (e: any) => onClick(e);

  const diamonds = {
    pink,
    blue,
    green,
  };
  return (
    <button onClick={handleClick} className={styles.button}>
      <img src={diamonds[color]} alt="diamond" />
      {text}
    </button>
  );
};

export default DiamondButton;
